// extracted by mini-css-extract-plugin
export default {"loginPage":"login_loginPage__D7sQr"};